import React from 'react';
import Leadership from '../components/Leadership';

const LeadershipPage = () => {
  return (
    <div>
      <Leadership />
    </div>
  );
};

export default LeadershipPage;

